import { Link } from 'react-router-dom';
import './Footer.css';
import logo_discord from "./logo_discord.svg";
import logo_instagram from "./logo_instagram.svg";
import logo_steam from "./logo_steam.svg";
import logo_tiktok from "./logo_tiktok.png";
import logo_x from "./logo_x.svg";

function Footer() {
  return (
    <main className='Footer'>
      <section className='Footer-Contact'>
        <p>
          Contact: <a href="mailto:enquiries@racctuality.co.uk">
            enquiries@racctuality.co.uk
          </a>
          <br/>
          Sign up to the <Link to="mailing-list">
            mailing list
          </Link> to stay updated.
          <br/>
          © Racctuality™ 2026 - All rights reserved.
        </p>
        <section>
          <a href="https://discord.gg/HPraUzZrfY">
            <img src={logo_discord} className='Footer-Logo' type="image/svg" alt="The Discord logo."/>
          </a>
          <a href="https://instagram.com/racctuality/">
            <img src={logo_instagram} className='Footer-Logo' type="image/svg" alt="The Instagram logo."/>
          </a>
          <a href="https://steamcommunity.com/groups/racctuality/">
            <img src={logo_steam} className='Footer-Logo' type="image/svg" alt="The Steam logo."/>
          </a>
          <a href="https://tiktok.com/@racctuality/">
            <img src={logo_tiktok} className='Footer-Logo' type="image/png" alt="The Tiktok logo."/>
          </a>
          <a href="https://x.com/racctuality">
            <img src={logo_x} className='Footer-Logo' type="image/png" alt="The X logo."/>
          </a>
        </section>
      </section>
      <section className='Footer-Company-Info'>
        <p>
          Racctuality Limited is proudly based in the United Kingdom.<br/>
        </p>
        <p>
          Company Number (England and Wales): 16932627<br/>
          Registered at:<br/>
          124-128 City Road,<br/>
          London,<br/>
          England,<br/>
          EC1V 2NX
        </p>
      </section>
    </main>
  );
}

export default Footer;
